module.exports = __webpack_public_path__ + "static/img/hover-iocnQZ.4104736.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocnQZ.png
// module id = 5yce
// module chunks = 1